// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9eed4ccd","703":"84642645","787":"6a39ed21"}[chunkId] + ".chunk.js";
};